import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/language';
import { getStrLang } from '../Translate';
import toast, { Toaster } from 'react-hot-toast';

export default function Timer(props) {
  const { bankSelected } = useLanguage();
  const { lang } = useLanguage();
  const [totalTime, setTotalTime] = useState();
  const [horas, setHoras] = useState(2);
  const [minutos, setMinutos] = useState(0);
  const [segundos, setSegundos] = useState(0);

  useEffect(() => {
    let dataOrdem = sessionStorage.getItem("date_order");
    if(props.crypto){
      dataOrdem = sessionStorage.getItem("date_crypto");
    }
    if (dataOrdem !== null) {
      var startDate = new Date();
      console.log(dataOrdem);
      // Do your operations
      var endDate = addHours(props.countdown/60, dataOrdem);
      var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      setTotalTime(Math.floor(seconds));
    }
  }, []);

  function addHours(numOfHours, datetime) {
    let date = new Date(datetime);
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
    return date;
  }

  useEffect(() => {
    if (totalTime <= 0) {
      props.setExpirado(true);
      setHoras(0);
      setMinutos(0);
      setSegundos(0);
    }
  }, [totalTime]);


  setTimeout(() => {
    if (totalTime > 0) {
      setTotalTime(totalTime - 1);
      setHoras(Math.floor(totalTime / 60 / 60));
      setMinutos(Math.floor(totalTime / 60) % 60);
      setSegundos(totalTime % 60);
    }
  }, 1000);

  return (
    <div className="timer-component">
      <span>{horas.toString().padStart(2, "0")}</span>
      <span>:</span>
      <span>{minutos.toString().padStart(2, "0")}</span>
      <span>:</span>
      <span>{segundos.toString().padStart(2, "0")}</span>
      <Toaster
        toastOptions={{
          className: '',
          style: {
            border: '1px solid #0d4fb8',
            color: '#0d4fb8',
            padding: '12px',
            top: '300px',
            //  position: 'relative',
          },
        }}
      />
    </div>
  );
}
